import { Directive, forwardRef, Attribute } from "@angular/core";
import { Validator, AbstractControl, NG_VALIDATORS } from "@angular/forms";

@Directive({
  selector:
    "[country][formControlName],[country][formControl],[country][ngModel]",
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => CountryValidator),
      multi: true,
    },
  ],
})
export class CountryValidator implements Validator {
  constructor(@Attribute("country") public country: any) {}

  validate(c: AbstractControl): { [key: string]: any } {
    // self value
    let v = c.value;

    // value not equal
    if (v && !v.id) {
      return {
        country: false,
      };
    }

    return null;
  }
}



// WEBPACK FOOTER //
// ./src/app/_directives/country.validator.ts